import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Check, Plus } from "lucide-react";
import { ServiceCard } from "./ServiceCard";

/** Step 2 — choose photography/video services, plus optional virtual staging and twilight add-ons. */
export function ServiceSelector({ form }) {
  const { catalog, grouped, blocks, services, toggleService, vsOption, setVsOption, twilightOption, setTwilightOption } = form;
  return (
    <div data-testid="step-services" className="space-y-8 fade-up">
      <h2 className="font-display text-3xl tracking-tight">Choose your services</h2>

      {grouped.map(({ category, items }) => (
        <div key={category} className="space-y-3">
          <div className="text-[11px] font-mono uppercase tracking-[0.28em] text-slate-500">{category}</div>
          {items.map((s) => {
            const price = Number(s.price_tiers?.[blocks] ?? (s.base + s.increment * blocks)).toFixed(2);
            const selected = services.includes(s.id);
            return (
              <ServiceCard key={s.id} testid={`add-service-${s.id}`} img={s.img} name={s.name}
                desc={s.desc} meta={s.meta} selected={selected} onClick={() => toggleService(s.id)}
                right={<div className="flex items-center gap-2">
                  <span className="font-display text-2xl">${price}</span>
                  <span className={`h-8 w-8 flex items-center justify-center border transition-colors ${selected ? "bg-slate-900 border-slate-900 text-slate-50" : "border-slate-300 text-slate-400"}`}>
                    {selected ? <Check className="h-4 w-4" /> : <Plus className="h-4 w-4" />}
                  </span>
                </div>} />
            );
          })}
        </div>
      ))}

      {catalog?.virtual_staging_meta && (
        <div className="space-y-3">
          <div className="text-[11px] font-mono uppercase tracking-[0.28em] text-slate-500">{catalog.virtual_staging_meta.category}</div>
          <ServiceCard img={catalog.virtual_staging_meta.img} name={catalog.virtual_staging_meta.name}
            desc={catalog.virtual_staging_meta.desc} selected={!!vsOption} noClick
            right={<Select value={vsOption || "none"} onValueChange={(v) => setVsOption(v === "none" ? "" : v)}>
              <SelectTrigger data-testid="vs-option" className="rounded-none border-slate-300 w-[150px]"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Not added</SelectItem>
                {(catalog?.virtual_staging || []).map((v) => <SelectItem key={v.id} value={v.id}>{v.label} — ${v.price}</SelectItem>)}
              </SelectContent>
            </Select>} />
        </div>
      )}

      {catalog?.twilight_meta && (
        <div className="space-y-3">
          <div className="text-[11px] font-mono uppercase tracking-[0.28em] text-slate-500">{catalog.twilight_meta.category}</div>
          <ServiceCard img={catalog.twilight_meta.img} name={catalog.twilight_meta.name}
            desc={catalog.twilight_meta.desc} selected={!!twilightOption} noClick
            right={<Select value={twilightOption || "none"} onValueChange={(v) => setTwilightOption(v === "none" ? "" : v)}>
              <SelectTrigger data-testid="twilight-option" className="rounded-none border-slate-300 w-[150px]"><SelectValue /></SelectTrigger>
              <SelectContent>
                <SelectItem value="none">Not added</SelectItem>
                {(catalog?.twilight_options || []).map((v) => <SelectItem key={v.id} value={v.id}>{v.label} — ${v.price}</SelectItem>)}
              </SelectContent>
            </Select>} />
        </div>
      )}
    </div>
  );
}
